import { axios } from '@/utils/request'
// 相关城市的数据
export function getGrabAreaList (parameter) {
  return axios({
    url: '/order/grabOrder/selectGrabOrderList',
    method: 'post',
    data: JSON.stringify(parameter),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 试点省份
export function getProvinceByStartOrNot (parameter) {
  return axios({
    url: '/basicdata/province/getProvinceByStartOrNot',
    method: 'get',
    params: parameter
  })
}
// 试点城市
export function getCityByStartOrNot (parameter) {
  return axios({
    url: '/basicdata/city/getCityByStartOrNot',
    method: 'get',
    params: parameter
  })
}
export function updateAreaPrice (parameter) {
  return axios({
    url: '/order/grabOrder/updateArea',
    method: 'post',
    data: JSON.stringify(parameter),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 是否开启抢单
export function updateAreaFlag (parameter) {
  return axios({
    url: '/order/grabOrder/updateAreaFlag',
    method: 'post',
    data: JSON.stringify(parameter),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
